import Button from '@/components/Button'
import ChampionshipSmallCard from '@/components/Cards/ChampionshipSmallCard'
import Container from '@/components/Container'
import Section from '@/components/Section'
import Title from '@/components/Title'
import { usePage } from '@/hooks'
import React from 'react'

const Championships = ({ championships }): React.ReactElement | null => {
  const page = usePage()
  if (championships.length === 0) {
    return null
  }

  const link = page.init_state.global.config.championships
  return (
    <Section>
      <Container>
        <Title type='h2' theme='h3'>
          Чемпионаты
        </Title>
        {championships.map((el) => {
          return <ChampionshipSmallCard championship={el} key={el.id} />
        })}
        <Button href={link} size='large' wide outline>
          Все чемпионаты
        </Button>
      </Container>
    </Section>
  )
}

export default Championships
